"use client";

import { homePath } from "@/components/auth-guard";
import { useAuth } from "@/contexts/auth-context";
import { useRouter } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function Home() {
  const { isAuthenticated, loading, getUserType } = useAuth();
  const router = useRouter();
  const t = useTranslations("common");

  useEffect(() => {
    if (loading) return;
    router.replace(isAuthenticated ? homePath(getUserType()) : "/login");
  }, [isAuthenticated, loading, router, getUserType]);

  // Always show loading state - no default content
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        <p className="text-gray-600 text-sm">{t("loading")}</p>
      </div>
    </div>
  );
}
